import axios from 'axios';
import { history } from '../../../History';
import config from '../../../config/api';
import { message } from 'antd';
import { resetAuthReducer } from '../Auth/AuthActions';

export const setFilterToAdd = (data) => ({
  type: 'SET_FILTER_TO_ADD',
  data
});

export const setSecTabToAdd = (data) => ({
  type: 'SET_SEC_TAB_TO_ADD',
  data
});

export const setPrimaryTabIcon = (data) => ({
  type: 'SET_PRIMARY_ICON',
  data
});

export const setPrimaryTabName = (data) => ({
  type: 'SET_PRIMARY_TAB_NAME',
  data
});

export const secSecTabOptions = (data) => ({
  type: 'SET_SEC_TAB_OPTIONS',
  data
})

export const secSecTabSelected = (data) => ({
  type: 'SET_PRIMARY_TAB_SEC_TAB',
  data
})

export const setAddingFilterStatus = (data) => ({
  type: 'SET_ADDING_FILTER_STATUS',
  data
})

export const setAddingSecTabStatus = (data) => ({
  type: 'SET_ADDING_SEC_TAB_STATUS',
  data
})

export const setAddingPrimaryTabStatus = (data) => ({
  type: 'SET_ADDING_PRIMARY_TAB_STATUS',
  data
})

export const setTemplateName = (data) => ({
  type: 'SET_TEMPLATE_TO_ADD',
  data
})

export const setTemplateReportList = (data) => ({
  type: 'SET_TEMPLATE_REPORT_LIST',
  data
})

export const setReportsToAdd = (data) => ({
  type: 'SET_REPORTS_TO_ADD',
  data
})

export const setAddingTemplateStatus = (data) => ({
  type: 'SET_ADDING_TEMPLATE_STATUS',
  data
})

export const addFilter = (data) => {
  return function (dispatch) {
    dispatch(setAddingFilterStatus(true));
    const token = JSON.parse(sessionStorage.getItem('user')).data.token;
    const email = JSON.parse(sessionStorage.getItem('user')).data.email;
    const role = JSON.parse(sessionStorage.getItem('user')).data.role;
    const form_data = {
      cmd: 'filter:add',
      auth: { key: token },
      name: data,
      authUser: {
        role, email
      }
    }
    axios({
      method: 'post',
      url: `${config.api_url}`,
      data: form_data
    })
      .then(response => {
        console.log(response.data);
        if (response.data.reply.code === 200) {
          message.success(response.data.reply.message);
          dispatch(setAddingFilterStatus(false));
          dispatch(setFilterToAdd(''));
        }
        else if (response.data.reply.code === 400) {
          dispatch(setAddingFilterStatus(false));
          dispatch(setFilterToAdd(''));
        }
        else if (response.data.reply.code === 401 || response.data.reply.code === 403) {
          message.error('You have been logged out! Please login to continue');
          dispatch(setFilterToAdd(''));
          dispatch(setAddingFilterStatus(false));
          dispatch(resetAuthReducer());
          history.push('/');
        }
      })
      .catch((error) => {
        dispatch(setFilterToAdd(''));
        dispatch(setAddingFilterStatus(false));
      })
  }
}

export const addSecTab = (data) => {
  return function (dispatch) {
    dispatch(setAddingSecTabStatus(true));
    const token = JSON.parse(sessionStorage.getItem('user')).data.token;
    const email = JSON.parse(sessionStorage.getItem('user')).data.email;
    const role = JSON.parse(sessionStorage.getItem('user')).data.role;
    const form_data = {
      cmd: 'secondaryTab:add',
      auth: { key: token },
      name: data,
      authUser: {
        role, email
      }
    }
    axios({
      method: 'post',
      url: `${config.api_url}`,
      data: form_data
    })
      .then(response => {
        if (response.data.reply.code === 200) {
          message.success(response.data.reply.message);
          dispatch(setAddingSecTabStatus(false));
          dispatch(setSecTabToAdd(''));
        }
        else if (response.data.reply.code === 400) {
          message.error(response.data.reply.message);
          dispatch(setAddingSecTabStatus(false));
          dispatch(setSecTabToAdd(''));
        }
        else if (response.data.reply.code === 401 || response.data.reply.code === 403) {
          message.error('You have been logged out! Please login to continue');
          dispatch(resetAuthReducer());
          dispatch(setSecTabToAdd(''));
          history.push('/');
        }
      })
      .catch((error) => {
        dispatch(setSecTabToAdd(''));
      })
  }
}

export const addPrimaryTab = (data) => {
  return function (dispatch) {
    dispatch(setAddingPrimaryTabStatus(true));
    const token = JSON.parse(sessionStorage.getItem('user')).data.token;
    const email = JSON.parse(sessionStorage.getItem('user')).data.email;
    const role = JSON.parse(sessionStorage.getItem('user')).data.role;
    const form_data = {
      cmd: 'tabs:add',
      auth: { key: token },
      name: data.name,
      icon: data.icon,
      secondary_tabs: data.secondary_tabs,
      authUser: {
        role, email
      }
    };
    axios({
      method: 'post',
      url: `${config.api_url}`,
      data: form_data
    })
      .then(response => {
        if (response.data.reply.code === 200) {
          message.success(response.data.reply.message);
          dispatch(setAddingPrimaryTabStatus(false));
          dispatch(secSecTabSelected([]));
          dispatch(setPrimaryTabName(''));
          dispatch(setPrimaryTabIcon(undefined));
        }
        else if (response.data.reply.code === 400) {
          message.error(response.data.reply.message);
          dispatch(setAddingPrimaryTabStatus(false));
          dispatch(secSecTabSelected([]));
          dispatch(setPrimaryTabName(''));
          dispatch(setPrimaryTabIcon(undefined));
        }
        else if (response.data.reply.code === 401 || response.data.reply.code === 403) {
          message.error('You have been logged out! Please login to continue');
          dispatch(setAddingPrimaryTabStatus(false));
          dispatch(secSecTabSelected([]));
          dispatch(setPrimaryTabName(''));
          dispatch(setPrimaryTabIcon(undefined));
          dispatch(resetAuthReducer());
          history.push('/');
        }
      })
      .catch((error) => {
        dispatch(setAddingPrimaryTabStatus(false));
        dispatch(secSecTabSelected([]));
        dispatch(setPrimaryTabName(''));
        dispatch(setPrimaryTabIcon(undefined));
      })
  }
}

export const getSecTabs = () => {
  return function (dispatch) {
    const token = JSON.parse(sessionStorage.getItem('user')).data.token;
    const email = JSON.parse(sessionStorage.getItem('user')).data.email;
    const role = JSON.parse(sessionStorage.getItem('user')).data.role;
    const form_data = {
      cmd: 'secondaryTab:list',
      auth: { key: token },
      authUser: {
        role, email
      }
    }
    axios({
      method: 'post',
      url: `${config.api_url}`,
      data: form_data
    })
      .then(response => {
        if (response.data.reply.code === 200) {
          dispatch(secSecTabOptions(response.data.reply.message));
        }
        else if (response.data.reply.code === 401 || response.data.reply.code === 403) {
          message.error('You have been logged out! Please login to continue');
          dispatch(resetAuthReducer());
          history.push('/');
        }
      })
      .catch((error) => {
        console.log(error);
      })
  }
}

export const addTemplate = (name, reports) => {
  return function (dispatch) {
    dispatch(setAddingTemplateStatus(true));
    const token = JSON.parse(sessionStorage.getItem('user')).data.token;
    const email = JSON.parse(sessionStorage.getItem('user')).data.email;
    const role = JSON.parse(sessionStorage.getItem('user')).data.role;
    const form_data = {
      cmd: 'reportTemplate:add',
      auth: { key: token },
      name: name,
      report_ids: reports,
      authUser: {
        role, email
      }
    };
    axios({
      method: 'post',
      url: `${config.api_url}`,
      data: form_data
    })
      .then(response => {
        if (response.data.reply.code === 200) {
          message.success(response.data.reply.message);
          dispatch(setAddingTemplateStatus(false));
          dispatch(setTemplateName(''));
          dispatch(setReportsToAdd([]));
          dispatch(setTemplateReportList([]));
        }
        else if (response.data.reply.code === 400) {
          message.error(response.data.reply.message);
          dispatch(setAddingTemplateStatus(false));
          dispatch(setTemplateName(''));
          dispatch(setReportsToAdd([]));
          dispatch(setTemplateReportList([]));
        }
        else if (response.data.reply.code === 401 || response.data.reply.code === 403) {
          message.error('You have been logged out! Please login to continue');
          dispatch(setAddingTemplateStatus(false));
          dispatch(resetAuthReducer());
          dispatch(setTemplateName(''));
          dispatch(setReportsToAdd([]));
          dispatch(setTemplateReportList([]));
          history.push('/');
        }
      })
      .catch((error) => {
        dispatch(setAddingTemplateStatus(false));
        dispatch(resetAuthReducer());
        dispatch(setTemplateName(''));
        dispatch(setReportsToAdd([]));
        dispatch(setTemplateReportList([]));
      })
  }
}


// WEBPACK FOOTER //
// ./src/redux/actions/Misc/MiscActions.js